var f = Object.defineProperty;
var c = (o, s, t) => s in o ? f(o, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[s] = t;
var h = (o, s, t) => c(o, typeof s != "symbol" ? s + "" : s, t);
import { ErrorWithViolations as u } from "./index7.mjs";
class E extends Error {
  constructor(t) {
    var r;
    super((r = t.errors.common) == null ? void 0 : r.join(""));
    h(this, "errors");
    this.errors = t.errors;
  }
  toErrorWithViolations({
    type: t,
    status: r,
    title: i,
    code: e
  }) {
    return new u({
      type: t,
      status: r,
      title: i,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, e, "")
    });
  }
  flattenObjectToViolations(t, r, i = "") {
    const e = [];
    return typeof t == "string" ? (e.push({ propertyPath: i, message: t, code: r }), e) : (Array.isArray(t) ? t.length === 1 ? e.push({ propertyPath: i, message: t[0], code: r }) : t.forEach((n, l) => {
      const a = `${i}[${l}]`;
      e.push(...this.flattenObjectToViolations(n, r, a));
    }) : t !== null && typeof t == "object" && Object.entries(t).forEach(([n, l]) => {
      const a = i ? `${i}.${n}` : n;
      e.push(...this.flattenObjectToViolations(l, r, a));
    }), e);
  }
}
export {
  E as ErrorWithFields
};
